import { forwardRef, type ChangeEvent } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface NumberFieldProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type'
> {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  min?: number;
  step?: number | 'any';
}

function parseNumericInput(raw: string): number | undefined {
  if (raw === '') return undefined;
  const parsed = Number(raw);
  if (Number.isNaN(parsed)) return undefined;
  return parsed;
}

export const NumberField = forwardRef<HTMLInputElement, NumberFieldProps>(
  ({ value, onChange, className, step = 'any', ...props }, ref) => (
    <Input
      ref={ref}
      type="number"
      step={step}
      className={cn('h-10', className)}
      value={value ?? ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        onChange(parseNumericInput(event.target.value))
      }
      {...props}
    />
  ),
);

NumberField.displayName = 'NumberField';
